// Saga Helpers
import {takeLatest, call, put, takeEvery, select} from 'redux-saga/effects';
import {push} from 'connected-react-router'
import routes from '../../config/routes';

// Import Events Constatns
import {
    GET_SINGLE_EVENT,
    GET_SINGLE_EVENT_SUCCESS,
    GET_SINGLE_EVENT_ERROR,
    EDIT_EVENT,
    EDIT_EVENT_SUCCESS,
    EDIT_EVENT_ERROR,
    GET_SIMILIAR_EVENTS,
    GET_SIMILIAR_EVENTS_SUCCESS,
    GET_SIMILIAR_EVENTS_ERROR,
    GET_EVENTS,
    GET_EVENTS_SUCCESS,
    GET_EVENTS_ERROR,
    GET_COMPANIES,
    GET_COMPANIES_SUCCESS,
    GET_COMPANIES_ERROR,
    GET_CITIES,
    GET_CITIES_ERROR,
    GET_CITIES_SUCCESS,
    EVENT_ITEMS_PER_PAGE,
    SIMILAR_EVENTS_ITEMS_PER_PAGE,
    GET_PACKAGES, 
    GET_PACKAGES_ERROR, 
    GET_PACKAGES_SUCCESS,
    EXPIRED_EVENTS_PER_PAGE,
    GET_EXPIRED_EVENTS,
    GET_EXPIRED_EVENTS_SUCCESS,
    GET_EXPIRED_EVENTS_ERROR,
    DELETE_EVENT_SUCCESS,
    DELETE_EVENT_ERROR,
    DELETE_EVENT
} from './constants'

// Import Notifications and Store Service
import {setNotificationSuccess, setNotificationError} from '../Notifications/actions';
import {getAllEvents as getAllEventsAction} from './actions';
import StoreService from '../../utils/StoreService'

// Import Event Service
import { 
  getSingleEvent, 
  editEventService, 
  createEventService, 
  getSimiliarEvents, 
  getAllEvents, 
  getExpiredEventsService,
  getCompaniesProfiles, 
  getCitiesService, 
  getPackagesService, 
  deleteEventService
} from './service';
import intl from '../../intl';
import generalMessages from '../generalMessages';
import TagManager from 'react-gtm-module';
import gtm from '../../config/gtm'
import { AxiosError, AxiosResponse } from 'axios';
import roles from '../../config/roles'
import { makeSelectUserRole } from '../App/selectors';

// Get ALl Events
function* EventFlow(action: any) {
  const {category, page, search, admin} = action;

  try {
    const response: AxiosResponse = yield call(getAllEvents, page, EVENT_ITEMS_PER_PAGE, category, search, admin);
    yield put({type:GET_EVENTS_SUCCESS, response});

  } catch(error) {
      yield put({type:GET_EVENTS_ERROR, error})  
  }
}

// Get Expired Events
function* getExpiredEventsFlow(action: any) {
  const {category, page, search} = action;

  try {
    const response: AxiosResponse = yield call(getExpiredEventsService, page, EXPIRED_EVENTS_PER_PAGE, category, search);
    yield put({type:GET_EXPIRED_EVENTS_SUCCESS, response});

  } catch(error) {
      yield put({type:GET_EXPIRED_EVENTS_ERROR, error})  
  }
}

// Get Event Details
function* getEventDetails(action: any) {
  const {id} = action;
  try {
    const response: AxiosResponse = yield call(getSingleEvent, id);
    yield put({type: GET_SINGLE_EVENT_SUCCESS, response})
  } catch (error) {
    yield put({type: GET_SINGLE_EVENT_ERROR, error})
  }
}

// Create Edit Event
function* editEvent(action: any) {
  const {data} = action;
  const {id, package_id, preview, assigned_to, task_id, task_type} = data;
  const role: string = yield select(makeSelectUserRole);

  try {
    // If is true give edit, otherwise give false
    if(id) {
      const response: AxiosResponse = yield call(editEventService, data, id);
      yield put({type: EDIT_EVENT_SUCCESS, response});
      StoreService.dispatch(setNotificationSuccess(intl.formatMessage(generalMessages.EditEventsNotif)));
      if(package_id === '') {
        yield put(push(routes.DashboardPage));
      } else {
        if(preview) {
          yield put(push(`/dashboard/payment/proinvoice/event/${response.data.unique_id}`));
        } else {
          yield role === roles.BUSINESS_USER ?  
          put(push(`/event/review/${response.data.unique_id}`)) :  
          assigned_to && task_id ?
            put(push(`${routes.DashboardPage}/tasks/${task_type}`))
          : put(push(`${routes.DashboardPage}/tasks`))
        }
      }
    } else {
      const response: AxiosResponse = yield call(createEventService, data);

      const tagManagerArgs = {
        dataLayer: {
            'eventCategory': data.category,
            'event': gtm.events.eventCreated,        
        },
      }
      TagManager.dataLayer(tagManagerArgs)

      yield put({type: EDIT_EVENT_SUCCESS, response});
      StoreService.dispatch(setNotificationSuccess(intl.formatMessage(generalMessages.CreateEventsNotif)));
      if(preview){
        yield put(push(`/dashboard/payment/proinvoice/event/${response.data.unique_id}`));
      } else {
        yield put(push(`/event/review/${response.data.unique_id}`));
      }
    }

  } catch (error) {

    if(error) {
      const {response} = error as AxiosError | any;

      const {data} = response;

      if(response && response.status === 422) {
        data?.errors?.slug ? StoreService.dispatch(setNotificationError("Uneo si link koji već postoji.")) : StoreService.dispatch(setNotificationError(intl.formatMessage(generalMessages.SomethingNotRight)));
      } else {
        StoreService.dispatch(setNotificationError(intl.formatMessage(generalMessages.SomethingNotRight)))
      }
    }
    yield put({type: EDIT_EVENT_ERROR, error})
  }
}

// Get Similiar Events
function* getAllSimiliarEventsFlow(action: any) {
  const {category, unique_id, page} = action;
  try {
    const response:AxiosResponse = yield call(getSimiliarEvents, category, unique_id, page, SIMILAR_EVENTS_ITEMS_PER_PAGE);
    yield put({type: GET_SIMILIAR_EVENTS_SUCCESS, response})
  } catch (error) {
    yield put({type: GET_SIMILIAR_EVENTS_ERROR, error})
  }
}

// Get Companies
function* getCompanies() {
  try {
    const response:AxiosResponse = yield call(getCompaniesProfiles);
  
    yield put({type: GET_COMPANIES_SUCCESS, response});
  } catch(error) {
    yield put({type: GET_COMPANIES_ERROR});
  }
}

// Cities
function* getCities(action: any) {
  const {city} = action;
  try {
    const response:AxiosResponse  = yield call(getCitiesService, city);
    yield put({type: GET_CITIES_SUCCESS, response});
  } catch (error) {
    yield put({type: GET_CITIES_ERROR, error});
  }
}

// Packages
function* getPackegesForEvent() {
  try {
    const response:AxiosResponse  = yield call(getPackagesService);
    yield put({type: GET_PACKAGES_SUCCESS, response});
  } catch(error) {
    yield put({type: GET_PACKAGES_ERROR});
  }
}


function* deleteEventFlow(action: any) {

  const {id, page} = action;

  try {
    const response: AxiosResponse = yield call(deleteEventService, id);
    yield put({type: DELETE_EVENT_SUCCESS, response})
    StoreService.dispatch(getAllEventsAction('', page, '', true));
  } catch (error) {
    yield put({type: DELETE_EVENT_ERROR, error})
  }
}


// Saga
export default function* eventsSaga() {
  yield takeEvery(GET_EVENTS, EventFlow);
  yield takeEvery(GET_EXPIRED_EVENTS, getExpiredEventsFlow);
  yield takeLatest(GET_SINGLE_EVENT, getEventDetails);
  yield takeLatest(GET_SIMILIAR_EVENTS, getAllSimiliarEventsFlow);
  yield takeLatest(GET_COMPANIES, getCompanies);
  yield takeEvery(GET_CITIES, getCities);
  yield takeEvery(GET_PACKAGES, getPackegesForEvent);
  yield takeEvery(EDIT_EVENT, editEvent);
  yield takeLatest(DELETE_EVENT, deleteEventFlow);
}
